import { Link } from 'react-router-dom';
import { Instagram, ArrowUpRight, Mail, Phone, MessageCircle } from 'lucide-react';
import Logo from '@/components/layout/Logo';
import { buttonVariants, Button } from '@/components/ui/button';
import { CONTACT_INFO } from '@/constants/contact';
import TechsflowLogo from "./TechsFlowLogo";

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="relative border-t border-border bg-background">
      <div className="mx-auto container-editorial pt-20 md:pt-28 pb-10">
        {/* Marquee-style large mark */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 pb-16">
          <div className="lg:col-span-6">
            {/* Oversized wordmark */}
            <div className="pb-10 select-none overflow-hidden" aria-hidden>
              <div className="font-serif tracking-tight leading-none text-[16vw] lg:text-[11rem] whitespace-nowrap text-foreground/90">
                TechsFlow<span className="text-sienna">.</span>
              </div>
            </div>

          </div>

          <div className="lg:col-span-6 grid grid-cols-2 md:grid-cols-3 gap-8">
            <div>
              <div className="label-eyebrow mb-4">Studio</div>
              <ul className="space-y-2.5 text-sm">
                <li><Link to="/work"       className="hover:text-sienna transition-colors">Work</Link></li>
                <li><Link to="/industries" className="hover:text-sienna transition-colors">Industries</Link></li>
                <li><Link to="/services"   className="hover:text-sienna transition-colors">Services</Link></li>
                <li><Link to="/process"    className="hover:text-sienna transition-colors">Process</Link></li>
                <li><Link to="/about"      className="hover:text-sienna transition-colors">About</Link></li>
              </ul>
            </div>
            <div>
              <div className="label-eyebrow mb-4">Reach</div>
              <ul className="space-y-2.5 text-sm">
                <li>
                  <a href={`mailto:${CONTACT_INFO.email}`} className="flex items-center gap-2 hover:text-sienna transition-colors">
                    <Mail className="w-3.5 h-3.5 shrink-0" />
                    {CONTACT_INFO.email}
                  </a>
                </li>
                <li>
                  <a href={CONTACT_INFO.phoneClean} className="flex items-center gap-2 hover:text-sienna transition-colors">
                    <Phone className="w-3.5 h-3.5" /> {CONTACT_INFO.phone}
                  </a>
                </li>
                <li>
                  <a href={CONTACT_INFO.whatsapp} target="_blank" rel="noreferrer"
                     className="flex items-center gap-2 hover:text-sienna transition-colors">
                    <MessageCircle className="w-3.5 h-3.5" /> WhatsApp
                  </a>
                </li>
                <li>
                  <a href={CONTACT_INFO.instagram} target="_blank" rel="noreferrer"
                     className="flex items-center gap-2 hover:text-sienna transition-colors">
                    <Instagram className="w-3.5 h-3.5" /> {CONTACT_INFO.instagramHandle}
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <div className="label-eyebrow mb-4">Availability</div>
              <p className="text-sm text-muted-foreground leading-relaxed">
                Taking new engagements for the current quarter. Discovery calls on Tue &amp; Thu, 10am–5pm IST.
              </p>
              <div className="mt-4 inline-flex items-center gap-2 text-xs font-mono uppercase tracking-widest">
                <span className="w-1.5 h-1.5 rounded-full bg-sienna animate-pulse" />
                Accepting briefs
              </div>
            </div>
          </div>
        </div>

        <div className="pt-6 border-t border-border flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-muted-foreground font-mono">
          <div className="flex items-center gap-2">
            <Logo className="w-4 h-4" />
            <span>© {year} TechsFlow Studio. All rights reserved.</span>
          </div>
          <div className="flex items-center gap-6">
            <span className="w-1.5 h-1.5 rounded-full bg-sienna animate-pulse" />
            <span>Based in Amravati, India</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
